/**
 * TV Listings Control: number of days of listings loaded and shown in the date picker.
 * Effective value: (1) global setting from app_settings (set by admins on Profile), (2) env VITE_TV_LISTINGS_DAYS (7 or 14). Default 7.
 * This module provides the env/default fallback only; useTvData reads the global setting from the DB first.
 */
const RAW = typeof import.meta !== 'undefined' && typeof import.meta.env !== 'undefined'
  ? (import.meta.env.VITE_TV_LISTINGS_DAYS as string | undefined)
  : undefined

const PARSED = RAW != null ? parseInt(RAW, 10) : NaN
export const TV_LISTINGS_DAYS: 7 | 14 = (PARSED === 7 || PARSED === 14) ? PARSED : 7

/**
 * Fallback listing duration when app_settings has no value (env/default). Used by useTvData when DB returns null.
 */
export function getTvListingsDays(): 7 | 14 {
  return TV_LISTINGS_DAYS
}
